import { USER_ID } from './constants';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const data = {
  authToken: localStorage.getItem('user-token') || '',
  refreshToken: localStorage.getItem('refresh-token') || '',
  authStatus: '',
  userProfile: {},
  userStatus: '',
  username: localStorage.getItem('user-name') || '',
  userId: localStorage.getItem(USER_ID) || null,
  confirmEmailLoadingStatus: '',
  forgotPasswordStatus: '',
  newPasswordStatus: '',
  userRoles: [],
  isCPA: false,
  CPAId: null,
};

export default {
  state: data,
  getters,
  mutations,
  actions,
};
